import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import cx from 'classnames';

import useMatchedChannelPage from '../../hooks/useMatchedChannelPage';
import appendQueryString from '../../utils/appendQueryString';
import { TRACKING_PAGEVIEW_SOURCE } from '../../../constants/tracking';

const ContentWrapper = styled.div.attrs({
  className: 'relative cursor-pointer',
})``;

const TitleWrapper = styled.div.attrs({
  className: 'flex items-center',
})``;

const DropDownWrapper = styled.div.attrs({
  className: 'absolute',
})`
  top: 100%;
  left: -32px;
  padding-top: 10px;
`;

const DropDownContainer = styled.div.attrs({
  className: 'Card Card--dark',
})`
  min-width: 146px;
  max-height: 380px;
  padding: 18px;
`;

/**
 *
 * @tofix DropDownContainer link is not focused
 */
const ChannelListMenu = (props) => {
  const { className, style, data: channels } = props;

  const {channelId, isChannelPage} = useMatchedChannelPage();

  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);

  return (
    <ContentWrapper
      className={className}
      style={style}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <TitleWrapper 
        tabIndex="0"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      >
        <p
          className={cx('mr-1', {
            'underline': (hovered || focused), 'text-brand-green-400': isChannelPage,
          })}
        >
          {isChannelPage
            ? channels?.find((channel) => channel.id.toString() === channelId)?.name ?? '劇庫'
            : '劇庫'}
        </p>
        <i
          className={cx('text-12', (hovered || focused) ? 'icon_expand_less' : 'icon_expand_more', {
            'text-brand-green-400': isChannelPage,
          })}
          css={`
            transform-origin: center;
            transform: scale(0.7);
          `} /* for setting font size (Chrome default font size is 12px) */
        />
      </TitleWrapper>

      {(hovered || focused) && (
        <DropDownWrapper>
          <DropDownContainer className="flex flex-col">
            <div className="flex flex-col items-start overflow-y-auto no-scrollbar">
              {channels?.map((channel) => (
                <Link
                  key={channel.id}
                  to={appendQueryString(`/channel/${channel.id}`, {
                    source: TRACKING_PAGEVIEW_SOURCE.CHANNEL_LIST_MENU,
                    feed_id: channel.feedId,
                    channel_id: channel.id,
                  })}
                  className={cx('Btn Btn--text Btn--sm flex-none font-500', {
                    'text-brand-green-400': channel.id.toString() === channelId,
                  })}
                >
                  {channel.name}
                </Link>
              ))}
            </div>
          </DropDownContainer>
        </DropDownWrapper>
      )}
    </ContentWrapper>
  );
};

export default ChannelListMenu;
